<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Módulos</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoModulo" />

    <SGPTabelaComponent
      v-if="listaDeModulos.length"
      :colunas="colunas"
      :dados="listaDeModulos"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Cadastro de Módulo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioModuloComponent
        :tipoFormulario="tipoFormulario"
        :modulo="modulo"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingModulos"/>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioModuloComponent from '../components/FormularioModuloComponent.vue'

export default {
  components: { FormularioModuloComponent },
  name: 'ModuloPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      modulosSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      modulo: {}
    }
  },
  created () {
    this.listarModulos();
  },
  computed: {
    ...mapGetters('modulos', ['listaDeModulos', 'loadingModulos']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'modulo',
          label: 'Módulo',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('modulos', ['listarModulos','excluirModulos']),

    gerenciadorDeSelecionados (selecionados) {
      this.modulosSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.modulo = this.modulosSelecionados[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirModulos(this.modulosSelecionados);
      this.deletarDados = false;
    },

    adicionarNovoModulo () {
      this.modulo = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>
